import { useState, useEffect, useContext, useCallback } from 'react';
import { AuthContext } from '../context/AuthContext';
import layoutService from '../services/layoutService';

const DEFAULT_CONFIG = {
    show_logo: true,
    show_favorites: true,
    favorites_position: 'in_header',
    show_search: true,
    search_type: 'product',
    show_customer_selector: true,
    show_cart: true,
    show_checkout: true,
    show_network_status: true,
    show_user_info: true,
    show_left_sidebar_toggle: true,
    show_right_sidebar_toggle: true,
    search_placeholder: 'Search products...',
};

const GUEST_CONFIG = {
    show_logo: true,
    show_favorites: false,
    favorites_position: 'in_header',
    show_search: true,
    search_type: 'product',
    show_customer_selector: false,
    show_cart: false,
    show_checkout: false,
    show_network_status: false,
    show_user_info: true,
    show_left_sidebar_toggle: false,
    show_right_sidebar_toggle: false,
    search_placeholder: 'Search products...',
};

const useHeaderConfig = () => {
    const { user, isAuthenticated, isSuperuser } = useContext(AuthContext);
    const [config, setConfig] = useState(() => layoutService.getCachedHeaderConfig());
    const [loading, setLoading] = useState(true);
    const [hasHeader, setHasHeader] = useState(true);

    const fetchConfig = useCallback(async () => {
        if (!isAuthenticated || !user) {
            setConfig(GUEST_CONFIG);
            setHasHeader(true);
            setLoading(false);
            return;
        }

        try {
            const result = await layoutService.getMyHeaderConfig();
            if (result) {
                setConfig(result);
                setHasHeader(true);
            } else if (isSuperuser) {
                setConfig(DEFAULT_CONFIG);
                setHasHeader(true);
            } else {
                setConfig(null);
                setHasHeader(false);
            }
        } catch {
            if (isSuperuser) {
                setConfig(DEFAULT_CONFIG);
                setHasHeader(true);
            }
        } finally {
            setLoading(false);
        }
    }, [isAuthenticated, user, isSuperuser]);

    useEffect(() => {
        fetchConfig();
    }, [fetchConfig]);

    return {
        config: config || DEFAULT_CONFIG,
        loading,
        hasHeader,
        refetch: fetchConfig
    };
};

export default useHeaderConfig;
